import Http from "../../js/Http";

const dadosRecuperaSaldos = {
  namespaced: true,
  state: {
    saldos: [],
    saldosLote: [],
    totalRegistros: 0,
    temErros: false,
    mensagemErro: "",
    carregando: false,
  },
  mutations: {
    setDadosRecuperaSaldos(state, payload) {
      state.saldos = payload.Saldos || [];
      state.saldosLote = payload.SaldosLote || [];
      state.totalRegistros = payload.TotalRegistros || 0;
      state.temErros = payload.TemErros || false;
      state.mensagemErro = payload.MensagemErro || "";
    },
    setCarregando(state, valor) {
      state.carregando = valor;
    },
    setErro(state, mensagem) {
      state.temErros = true;
      state.mensagemErro = mensagem;
      state.carregando = false;
      state.saldos = [];
      state.saldosLote = [];
      state.totalRegistros = 0;
    },
    limparDados(state) {
      state.saldos = [];
      state.saldosLote = [];
      state.totalRegistros = 0;
      state.temErros = false;
      state.mensagemErro = "";
    },
  },
};

const RecuperaSaldosStore = new window.Vuex.Store({
  modules: {
    dadosRecuperaSaldos: dadosRecuperaSaldos,
  },
  actions: {
    loadRecuperaSaldos: ({ commit }, payload) => {
      commit("dadosRecuperaSaldos/setCarregando", true);
      commit("dadosRecuperaSaldos/limparDados");

      // Monta a instância Vue sobre o elemento da página uma única vez;
      // as consultas seguintes apenas atualizam o estado (loading/erro/dados são reativos).
      if (!window.recuperaSaldosApp || !window.recuperaSaldosApp.$el) {
        window.recuperaSaldosApp = new window.Vue({
          el: "#recuperaSaldosApp",
          store: Benner.Corporativo.Materiais.RecuperaSaldosStore,
        });
      }

      Http.post("api/materiais/consultas/recuperarSaldosDetalhados", payload)
        .then((resultado) => {
          commit("dadosRecuperaSaldos/setDadosRecuperaSaldos", resultado.body);
        })
        .catch((erro) => {
          console.error("Erro ao recuperar saldos:", erro);
          commit("dadosRecuperaSaldos/setErro", erro.message || "Erro ao buscar dados");
        })
        .finally(() => {
          commit("dadosRecuperaSaldos/setCarregando", false);
        });
    },
  },
});

export default RecuperaSaldosStore;

